import { render, staticRenderFns } from "./bill-check.vue?vue&type=template&id=ddc0a89c&scoped=true"
import script from "./bill-check.vue?vue&type=script&lang=ts"
export * from "./bill-check.vue?vue&type=script&lang=ts"
import style0 from "./bill-check.vue?vue&type=style&index=0&id=ddc0a89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc0a89c",
  null
  
)

export default component.exports